import { useSyncExternalStore } from 'react';

/** Breakpoints of the handoff (PLAN.md 8.1): < 768 mobile, ≤ 1360 compact topbar, 1440 reference. */
export const MOBILE_QUERY = '(max-width: 767px)';
export const COMPACT_QUERY = '(max-width: 1360px)';
export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

function subscribe(query: string, onChange: () => void): () => void {
  const list = window.matchMedia(query);
  list.addEventListener('change', onChange);
  return () => list.removeEventListener('change', onChange);
}

/** True while the media query matches; re-renders on change. False during server rendering. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => subscribe(query, onChange),
    () => window.matchMedia(query).matches,
    () => false,
  );
}

export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY);
}

export function useIsCompact(): boolean {
  return useMediaQuery(COMPACT_QUERY);
}

export function usePrefersReducedMotion(): boolean {
  return useMediaQuery(REDUCED_MOTION_QUERY);
}
